interface CacheEntry<T> {
  timestamp: number;
  data: T;
}

const isBrowser = typeof window !== 'undefined';

export const readPublicCache = <T>(key: string, maxAgeMs: number): T | null => {
  if (!isBrowser) return null;
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as CacheEntry<T>;
    if (!parsed || typeof parsed.timestamp !== 'number') return null;
    if (Date.now() - parsed.timestamp > maxAgeMs) return null;
    return parsed.data;
  } catch {
    return null;
  }
};

export const writePublicCache = <T>(key: string, data: T) => {
  if (!isBrowser) return;
  try {
    localStorage.setItem(key, JSON.stringify({ timestamp: Date.now(), data }));
  } catch {
    // ignore storage failures
  }
};
